import {disableBodyScroll, enableBodyScroll} from "body-scroll-lock";

export default () => {
    const menu: Element | null = document.querySelector(".mainmenu");
    const burger: Element | null = document.querySelector(".menu_hamburger");
    const toggleSubmenu = (element: Element) => {
        element.querySelector("ul").classList.toggle("visible");
    };
    const toggleMenu = () => {
        if (menu) {
            if (menu.classList.contains("visible")) {
                menu.classList.remove("visible");
                burger.classList.remove("open");
            } else {
                menu.classList.add("visible");
                burger.classList.add("open");
            }
        }
    };
    if (burger) {
        //burger.addEventListener("click", toggleMenu);
    }

    // New
    const contentWrapper: HTMLElement | null = document.getElementById('content-wrapper');
    const wrapper: HTMLElement | null = document.getElementById('wrapper');
    const mobile: HTMLElement | null = document.getElementById('mobile');
    if (burger && mobile) {
        const toggleMobileMenu = () => {
            if (contentWrapper.classList.contains("mobilemenu--open")) {
                wrapper.classList.remove('scroll-lock');
                document.documentElement.classList.remove('scroll-lock');
                contentWrapper.classList.remove("mobilemenu--open");
                enableBodyScroll(mobile);
            } else {
                document.documentElement.classList.add('scroll-lock');
                wrapper.classList.add('scroll-lock');
                contentWrapper.classList.add("mobilemenu--open");
                disableBodyScroll(mobile);
            }
        };
        burger.addEventListener("click", toggleMobileMenu);
    }
}